import {
    DEFAULT_MONITORING_PERIOD_DAYS,
    DEFAULT_NOTIFICATION_THRESHOLDS,
} from 'modules/settings/components/custom-notifications/custom-notification-form.constants';
import { OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';
import {
    OperatorCustomNotificationFormMode,
    OperatorCustomNotificationFormState,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.model';

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX = `${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.form`;

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_UNAVAILABLE_KEY = `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.notifications.unavailable`;

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGERS_GROUP_KEY = `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.triggers.group`;

export const UNATTRIBUTED_TRIGGER_MARKER = '*';

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGER_UNAVAILABLE_OPTION_KEY = `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.triggers.option-unavailable`;

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGERS_HINT_KEY = `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.triggers.hint`;

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_DEFAULT_STATE: OperatorCustomNotificationFormState = {
    name: '',
    deviceTypes: { draftIds: [], selectedIds: [] },
    triggers: { draftIds: [], selectedIds: [] },
    windowDays: DEFAULT_MONITORING_PERIOD_DAYS,
    notifications: DEFAULT_NOTIFICATION_THRESHOLDS,
    isResettable: false,
    requiresCommentOnReset: false,
};

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_HEADER_KEYS: Record<OperatorCustomNotificationFormMode, string> = {
    add: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.add.title`,
    edit: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.edit.title`,
};

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_SUBMIT_KEYS: Record<OperatorCustomNotificationFormMode, string> = {
    add: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.add.submit`,
    edit: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.edit.submit`,
};

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_OPTIONAL_SETTINGS_KEYS = {
    title: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.optional-settings.title`,
    resetTitle: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.optional-settings.reset.title`,
    resetHint: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.optional-settings.reset.hint`,
    commentTitle: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.optional-settings.comment.title`,
    commentHint: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.optional-settings.comment.hint`,
};

export const OPERATOR_CUSTOM_NOTIFICATION_FORM_EDIT_CONFIRMATION_KEYS = {
    title: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.edit.confirmation.title`,
    question: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.edit.confirmation.question`,
    consequence: `${OPERATOR_CUSTOM_NOTIFICATION_FORM_I18N_PREFIX}.edit.confirmation.consequence`,
};
